import { HStack, IconButton, Steps, Text } from '@genial/components';
import { Color } from '@genial/design-tokens';
import React from 'react';

import { NewContractSteps } from '../../types';

interface HeaderProps {
  currentStep: NewContractSteps;
  hideSteps: boolean;
  onBack: () => void;
}

export const Header: React.FC<HeaderProps> = ({ currentStep, hideSteps, onBack }) => {
  return (
    <HStack justifyContent="space-between" alignItems="center">
      <HStack alignItems="center" space="inline.nano">
        <IconButton
          onPress={onBack}
          icon="ArrowLeft"
          iconSize="xs"
          p={0}
          iconColor={Color['neutral.black']}
          testId="fixed-fee-new-contract-back"
        />
        <Text variant="semibold">Nova contratação</Text>
      </HStack>

      {!hideSteps && (
        <Steps currentStep={currentStep} totalSteps={2} testId="fixed-fee-new-contract-steps" />
      )}
    </HStack>
  );
};
